import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import filePDF from "../assets/images/file-pdf.svg";
import api from "../utils/api";
import * as am5 from "@amcharts/amcharts5";
import Chart from "../components/Chart";
import PdfDownloader from "../components/PdfDownloader";
import Skeleton from "@mui/material/Skeleton";
import ErrorComp from "../components/ErrorComp";

const Retirement = (props) => {
  const [horizontalChartsData, setHorizontalChartsData] = useState([]);
  const [cardArrayData1, setcardArrayData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cardDataFund, setcardDataFund] = useState([]);

  const getRandomGreenToBlueColor = (index = 1) => {
    const colors = [
      "#0072E0",
      "#158EA5",
      "#88D892",
      "#5DC8DE",
      "#AD8EE1",
      "#C58EE1",
      "#8EE1D6",
      "#A6E18E",
      "#D8E18E",
      "#DE5DDA",
    ];
    const color = colors[index];
    return am5.color(color);
  };

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const processedDataSummary = [
          {
            field:
              props?.onboardingStep === 5 || (props?.balances && props?.balances.length)
                ? props?.balances?.[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item?.Total ),
                    0
                  ) 
                : 0,
          },
          {
            field:
              props?.onboardingStep === 5 || (props?.balances && props?.balances.length)
                ? props?.balances?.[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item?.Pensya ),
                    0
                  ) 
                : 0,
          },
          {
            field:
              props?.onboardingStep === 5 || (props?.balances && props?.balances.length)
                ? props?.balances?.[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item?.Hishtalmut ),
                    0
                  ) 
                : 0,
          },
        ];
        return processedDataSummary;
      } catch (error) {
        console.error("Error fetching balance data:", error);
      }
    };

    const fetchData = async () => {
      const k = await fetchData1();
      try {
        const transformedData = [
          {
            category: "סך יתרת ההלוואה",
            value: (props?.pensionPolicies || [])
              // .filter((item) => item?.duplicate !== true)
              .reduce((sum, item) => {
               const halvaa = Array.isArray(item?.Halvaa)
                 ? item?.Halvaa?.[0]
                 : item?.Halvaa ;
               return sum + parseFloat(halvaa?.SUG_HECHZER || 0);
             }, 0),
            settings: {
              fill: getRandomGreenToBlueColor(0),
            },
          },
          {
            category: "סך הלוואות ששולמו",
            value: (props?.pensionPolicies || [])
              // .filter((item) => item?.duplicate !== true)
              .reduce((sum, item) => {
               const halvaa = Array.isArray(item?.Halvaa)
                 ? item?.Halvaa?.[0]
                 : item?.Halvaa;
               return sum + parseFloat(halvaa?.YITRAT_HALVAA || 0);
             }, 0) ,
            settings: {
              fill: getRandomGreenToBlueColor(1),
            },
          },
        ];

        const cardDataFundTemp = [
          { title: "קצבה צפויה", RIBIT: 0 },
          { title: "הסכום הצפוי בגיל פרישה", SCHUM_HECHZER_TKUFATI: 0 },
        ];

        (props?.pensionPolicies || [])
          // .filter((item) => item?.duplicate !== true)
          .forEach((item) => {
           const YitraLefiGilPrisha = Array.isArray(item?.YitraLefiGilPrisha)
             ? item?.YitraLefiGilPrisha?.[0]
             : item?.YitraLefiGilPrisha ;

          const kupot = YitraLefiGilPrisha?.kupot ;

          kupot?.forEach((kupa) => {
            if (kupa?.KITZVAT_HODSHIT_TZFUYA) {
              cardDataFundTemp[0].RIBIT +=
                parseFloat(kupa?.KITZVAT_HODSHIT_TZFUYA || 0) ;
            }
          });

          if (YitraLefiGilPrisha?.TZVIRAT_CHISACHON_CHAZUYA_LELO_PREMIYOT) {
            cardDataFundTemp[1].SCHUM_HECHZER_TKUFATI +=
              parseFloat(
                YitraLefiGilPrisha?.TOTAL_CHISACHON_MITZTABER_TZAFUY || 0
              ) || 0;
          }
        });

        setcardDataFund(cardDataFundTemp);

    const transformedData2 = [
  {
    category: "קרן השתלמות",
    value: k?.[2]?.field,
    settings: {
      fill: getRandomGreenToBlueColor(0),
    },
  },
  {
    category: "קרן פנסיה",
    value: k?.[1]?.field,
    settings: {
      fill: getRandomGreenToBlueColor(1),
    },
  },
];

        const cardArrayData = [
          {
            title: "ממוצע % ריבית",
            RIBIT: (props?.pensionPolicies || [])
              // .filter((item) => item?.duplicate !== true)
              .length
              ? (props?.pensionPolicies || [])
                  // .filter((item) => item?.duplicate !== true)
                  .reduce((sum, item) => {
                   const halvaa = Array.isArray(item?.Halvaa)
                     ? item?.Halvaa?.[0]
                     : item?.Halvaa ;
                   return sum + parseFloat(halvaa?.RIBIT || 0);
                 }, 0) / (props?.pensionPolicies || [])
                    //  .filter((item) => item?.duplicate !== true)
                     .length
              : 0,
          },
          {
            title: "סה״כ החזרים תקופתיים",
            SCHUM_HECHZER_TKUFATI: (props?.pensionPolicies || [])
              // .filter((item) => item?.duplicate !== true)
              .reduce((sum, item) => {
               const halvaa = Array.isArray(item?.Halvaa)
                 ? item?.Halvaa?.[0]
                 : item?.Halvaa ;
               return sum + parseFloat(halvaa?.SCHUM_HECHZER_TKUFATI || 0);
             }, 0),
          },
        ];

        setcardArrayData1(cardArrayData);

        let arrayDataForChart = [
          {
            id: `filteredLIFEArrayData1-${props?.pensionPolicies?.length }`,
            title: "LIFE",
            total: k?.[0]?.field ,
            totalLabel: "סה״כ חסכון נוכחי",
            data: transformedData2,
          },
        ];

        setHorizontalChartsData(arrayDataForChart);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [props?.pensionPolicies, props?.balances, props?.onboardingStep]);

  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    setUserData(props?.data );
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, [props?.data]);

  return (
    <>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData?.full_name }
              </Link>
              <Typography>
                <b>פרישה</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים , {UserData?.full_name }</h1>
          </div>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="Retirement.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
           <p>
  ברוכים הבאים ללוח הבקרה הפיננסי שלכם! כאן תוכלו לגלות את כל המידע הדרוש
  לתכנון ולניהול של הפרישה שלכם!
  <br />
  עמוד זה מציע מבט מקיף על המצב הכלכלי שלכם, תוכלו להבין כמה כסף צברתם עד היום,
  כמה מתוכו נמצא בקרנות הפנסיה וקופות הגמל, חסכון וכו׳.
  <br />
  בנוסף תוכלו לקבל תמונה מקיפה על הקצבאות והצבירות בחשבונות שלכם,
  חסכונות והשקעות. תקבלו תובנות חשובות על נתוני הפנסיה, תזהו הזדמנויות
  לחיסכון נוסף ותוכלו לעקוב אחר ההתקדמות שלכם לעבר היעדים הפיננסיים.
  עם טיפים מותאמים אישית ותצוגה ברורה של הנתונים הכלכליים שלכם,
  תוכלו לקבל החלטות מושכלות ולשלוט בעתיד הפיננסי שלכם.
</p>
        </div>
        <div className="btns-row">
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="Retirement.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
        </div>
      </div>
      {props.onboarding_error == 1 && <ErrorComp />}

      <div className="horizontalChart-section">
        <div className="title">
          <h2>פרישה</h2>
        </div>
        <div className="row chart-row">
          {horizontalChartsData.length === 0 && loading
            ? [...Array(2)].map((_, index) => (
                <div className="col-6" key={`horizontal-${index}`}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={500}
                    animation="wave"
                    sx={{
                      backgroundColor: "rgba(0, 0, 0, 0.05)",
                      borderRadius: 1,
                      marginBottom: 2,
                    }}
                  />
                </div>
              ))
            : horizontalChartsData.map((chart, index) => (
                <div className="col-6" key={`horizontal-${index}`}>
                  <Chart
                    id={`hor${index}`}
                    data={chart.data}
                    total={chart.total}
                    title={chart.title}
                    totalLabel={chart.totalLabel}
                    variant="horizontal"
                    count="2"
                    from="summary"
                    cardArrayData={index === 1 ? cardArrayData1 : cardDataFund}
                    indexKey={index}
                  />
                </div>
              ))}
        </div>
      </div>
    </>
  );
};

export default Retirement;
